import { render, staticRenderFns } from "./ApplicationBlock.vue?vue&type=template&id=66044eec&scoped=true"
import script from "./ApplicationBlock.vue?vue&type=script&lang=js"
export * from "./ApplicationBlock.vue?vue&type=script&lang=js"
import style0 from "./ApplicationBlock.vue?vue&type=style&index=0&id=66044eec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66044eec",
  null
  
)

export default component.exports